export default function MultiCheckbox(module) {
    angular.module(module)
        .component('multiCheckbox', {
            bindings: {
                allLabel: '@?',
                options: '<',
                modelAsString: '<?',
                onChange: '&?'
            },
            require: {
                ngModel: '?ngModel'
            },
            template: `
                <div ng-hide="!vm.allLabel" class="custom-radio">
                    <input type="checkbox" ng-checked="!vm.selections.length" />
                    <label ng-click="vm.clear()">{{vm.allLabel}}</label>
                </div>
                <div class="custom-radio" ng-repeat="option in vm.options track by option.value">
                    <input ng-model="option.active" type="checkbox" id="multi-checkbox-{{vm._id}}-{{$index}}" ng-true-value="true" ng-false-value="false" ng-change="vm.updateValue(option.value)">
                    <label for="multi-checkbox-{{vm._id}}-{{$index}}">
                        <span>{{option.label}}</span>
                    </label>
                </div>
            `,
            controller: multiCheckboxController,
            controllerAs: 'vm'
        });
    var id = 1;
    multiCheckboxController.$inject = ['$element', '$scope', '$compile'];
    function multiCheckboxController($element, $scope, $compile) {
        var vm = this;

        vm.$onInit = () => {
            vm._id = id++;
            $scope.$on('clear', vm.clear);
            vm.ngModel.$viewChangeListeners.push(vm.updateOptionsStatus);
        }

        vm.$onChanges = changes => {
            if (changes.options && changes.options.currentValue) {
                vm.updateOptionsStatus();
            }
        }

        vm.clear = () => {
            vm.updateOptionsStatus(true);
            vm.updateModel();
        }

        vm.updateOptionsStatus = (clear) => {
            vm.selections = clear ? [] : vm.ngModel.$viewValue || [];
            if (vm.options) {
                var stringifiedSelections = [];
                vm.selections.forEach(selection => {
                    stringifiedSelections.push(Array.isArray(selection) ? JSON.stringify(selection) : selection);
                })
                vm.options.forEach(option => {
                    option.active = stringifiedSelections.indexOf(Array.isArray(option.value) ? JSON.stringify(option.value) : option.value) > -1;
                });
            }
        }

        vm.updateValue = value => {
            var stringifiedSelections = [];
            vm.selections.forEach(selection => {
                stringifiedSelections.push(Array.isArray(selection) ? JSON.stringify(selection) : selection);
            })
            var index = stringifiedSelections.indexOf(Array.isArray(value) ? JSON.stringify(value) : value);
            if (index === -1) {
                vm.selections.push(value);
            }
            else {
                vm.selections.splice(index, 1);
            }
            vm.updateModel();
        }

        vm.updateModel = () => {
            var model = vm.modelAsString ? vm.ngModel.$setViewValue(vm.selections.join(',')) : vm.selections;
            if (vm.ngModel) {
                vm.ngModel.$setViewValue(model);
            }
            if (vm.onChange) {
                vm.onChange({
                    value: model
                });
            }
        }
    }
}